export default {
  methods: {
    loginIfUnauthorized(response) {
      if (!this.isResponseUnauthorized(response)) {
        return
      }

      this.redirectHttpRequest(response)
    },
    isResponseUnauthorized(response) {
      if (this.isHttpClientError(response)) {
        if ([401, 403].indexOf(this.getHttpStatusCode(response)) >= 0) {
          return true
        }
      }

      if (this.getHttpStatusCode(response)  === 500) {
        if ('You are not authorized to access this resource'.indexOf(this.getHttpErrorMessage(response)) >= 0) {
          return true
        }
      }

      return false
    }
  }
}
